import React, {
    type CSSProperties,
    forwardRef,
    type HTMLAttributes,
    type ReactElement
} from 'react';

import ColGroup from './ColGroup';
import { type ColsWidths, type ColumnConfig } from './Table.types';

import styles from './Table.module.scss';

type FixedHolderProps = {
    columns: ColumnConfig[];
    colsWidths: ColsWidths;
    tableStyle?: CSSProperties;
} & HTMLAttributes<HTMLDivElement>;

export const FixedHolder = forwardRef<HTMLDivElement, FixedHolderProps>(
    (
        { children, tableStyle, columns, colsWidths, ...rest }: FixedHolderProps,
        ref
    ): ReactElement => {
        return (
            <div ref={ref} {...rest}>
                <table className={styles.table} style={tableStyle}>
                    <ColGroup columns={columns} colWidths={colsWidths} />
                    {children}
                </table>
            </div>
        );
    }
);

FixedHolder.displayName = 'FixedHolder';
